import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { ComponentProps } from 'react';
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalDescription,
  ModalTitle,
} from '../../../../../design-system/modal/modal';
import { MarkNotInvoiceModalContent } from './mark-not-invoice-modal-content';
import { MarkNotPaidModalContent } from './mark-not-paid-modal-content';

type MarkNotPaidModalProps = {
  isOpen: boolean;
  invoiceInfo: ComponentProps<typeof MarkNotInvoiceModalContent>['invoiceInfo'];
  isLoading: boolean;
  onClose: () => void;
  onMarkNotPaid: () => Promise<void>;
};

export const MarkNotPaidModal = ({ isOpen, invoiceInfo, isLoading, onClose, onMarkNotPaid }: MarkNotPaidModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent className="h-max w-[520px] p-7">
        <VisuallyHidden>
          <ModalTitle>Mark not paid</ModalTitle>

          <ModalDescription>Mark not paid</ModalDescription>
        </VisuallyHidden>

        <ModalCloseButton onClick={onClose} aria-label="Close modal" />

        <MarkNotPaidModalContent invoiceInfo={invoiceInfo} isLoading={isLoading} onMarkNotPaid={onMarkNotPaid} />
      </ModalContent>
    </Modal>
  );
};
